module.exports = __webpack_public_path__ + "img/search-icon.8f011d50.svg";